/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Button } from '../../../Action';
const StyledButton = styled(Button) `
  ${({ theme: { font } }) => `
    width: 100%;
    justify-content: center;
    font-size: ${font.body.md.size};
    line-height: ${font.body.md.lineHeight};
  `}
`;
const formatAriaLabel = (rowsToLoad) => {
    return rowsToLoad === 1
        ? `Load ${rowsToLoad} more result`
        : `Load ${rowsToLoad} more results`;
};
const LoadMoreButton = ({ loadMoreValues, mt, }) => {
    const ariaLabel = useMemo(() => {
        if (!loadMoreValues)
            return undefined;
        const { totalRows, pageNumber, pageSize, loadingState } = loadMoreValues;
        // (pageNumber + 1) because we're indexing from 0
        const rowsRemaining = totalRows - (pageNumber + 1) * pageSize;
        const baseAriaLabel = rowsRemaining <= pageSize
            ? formatAriaLabel(rowsRemaining)
            : formatAriaLabel(pageSize);
        return loadingState === 'loading'
            ? baseAriaLabel.replace('Load', 'loading')
            : baseAriaLabel;
    }, [loadMoreValues]);
    return loadMoreValues ? (React.createElement(StyledButton, { ariaLabel: ariaLabel, variant: "link", text: "Load More", onClick: loadMoreValues === null || loadMoreValues === void 0 ? void 0 : loadMoreValues.handleShowMore, loading: loadMoreValues.loadingState === 'loading', mt: mt, type: "button" })) : null;
};
export { LoadMoreButton };
//# sourceMappingURL=LoadMoreButton.js.map